import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, ButtonGroup, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { useState } from 'react';
export const SectionBlockSelector = ({ sectionTitle, sectionDescription, blockTypes, onBlockAdd, onlyAdd }) => {
    const [selection, setSelection] = useState(blockTypes[0] || null);
    return (_jsxs(VStack, { p: "3", rounded: "xl", bg: "white", w: "48", maxW: "300px", shadow: "lg", border: "1px", borderColor: "gray.100", children: [_jsxs(Box, { w: "100%", children: [_jsx(Text, { fontSize: "md", fontWeight: "bold", textAlign: "left", children: sectionTitle }), _jsx(Text, { fontSize: "xs", color: "gray.400", children: sectionDescription })] }), _jsx(VStack, { w: "100%", align: "flex-start", gap: "1", children: blockTypes.map(block => {
                    return (_jsxs(HStack, { rounded: "md", w: "100%", p: "2", bg: selection?.slug === block.slug ? 'gray.200' : 'white', transition: "all 0.2s", cursor: "pointer", _hover: {
                            bg: 'gray.100'
                        }, onClick: () => {
                            if (selection?.slug === block.slug) {
                                setSelection(null);
                            }
                            else {
                                setSelection(block);
                            }
                        }, children: [_jsx(Icon, { asChild: true, children: _jsx(block.Icon, {}) }), _jsx(Text, { fontSize: "sm", children: block.label })] }, block.slug));
                }) }), _jsx(HStack, { w: "100%", children: onlyAdd ? (_jsx(Button, { size: "sm", flex: "1", disabled: selection == null, onClick: () => {
                        if (selection == null)
                            return;
                        onBlockAdd(selection, 'add');
                    }, children: "Add" })) : (_jsxs(ButtonGroup, { size: "sm", children: [_jsx(Button, { flex: "1", disabled: selection == null, onClick: () => {
                                if (selection == null)
                                    return;
                                onBlockAdd(selection, 'prepend');
                            }, children: "Prepend" }), _jsx(Button, { flex: "1", disabled: selection == null, onClick: () => {
                                if (selection == null)
                                    return;
                                onBlockAdd(selection, 'append');
                            }, children: "Append" })] })) })] }));
};
